import React from "react";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";

function HumanTracking() {
    const { t } = useTranslation();
    return (
        <>
            <div className="pad10"></div>
            <div className="pad10"></div>
            <Breadcrumb
                pageTitle={t("HUMAN TRAFFICKING PREVENTION POLICY  &  SAFETY REPORTING  &   AGE VERIFICATION")}
                text={t("GCNETWORKS WITH LOGIC maintains a strict zero-tolerance policy against human trafficking, sexual exploitation, forced labor, and any form of modern slavery. The platform www.luvbinder.com is intended exclusively for lawful social interaction between consenting adults.")}
            />
            <div className="container">
                <div className="box">
                    <h3>{t("Prohibited Activities")}</h3>
                    <p>{t("Users are strictly prohibited from using the platform to:")}</p>
                    <ul>
                        <li>{t("Promote or facilitate human trafficking")}</li>
                        <li>{t("Recruit individuals for sexual exploitation or forced labor")}</li>
                        <li>{t("Advertise escort services, prostitution, or sexual services")}</li>
                        <li>{t("Exploit or coerce individuals into sexual or labor activities")}</li>
                        <li>{t("Engage in grooming or recruitment of vulnerable individuals")}</li>
                    </ul>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Reporting and Enforcement")}</h3>
                    <p>
                        {t("The company actively monitors user activity and content in order to detect and prevent misuse of the platform. Any user suspected of violating this policy may be immediately suspended or permanently banned.")}
                    </p>
                    <p>
                        {t("Suspicious activities may be reported by users through our support contact channels. Where credible evidence of trafficking or exploitation is identified, the company may cooperate with relevant law enforcement authorities and provide necessary information in accordance with applicable laws.")}
                    </p>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Commitment")}</h3>
                    <p>
                        {t("GCNETWORKS WITH LOGIC is committed to maintaining a safe and responsible online environment and continuously works to prevent any misuse of its services related to trafficking, exploitation, or illegal activities.")}
                    </p>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("CONTENT POLICY / ACCEPTABLE USE POLICY")}</h3>
                    <p>
                        {t("This platform is intended for respectful communication between consenting adults. Users must comply with all applicable laws and community standards when using the service.")}
                    </p>
                    <p>{t("The following content is strictly prohibited:")}</p>
                    <ul>
                        <li>{t("Explicit nudity or sexually explicit material")}</li>
                        <li>{t("Pornographic images or videos")}</li>
                        <li>{t("Content involving minors")}</li>
                        <li>{t("Escort service advertisements or solicitation of prostitution")}</li>
                        <li>{t("Content promoting or facilitating human trafficking")}</li>
                        <li>{t("Content involving coercion, exploitation, abuse, or non-consensual activity")}</li>
                        <li>{t("Illegal services or illegal activities")}</li>
                        <li>{t("Harassment, threats, or abusive behavior")}</li>
                        <li>{t("Fraud, scams, or impersonation")}</li>
                    </ul>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Enforcement")}</h3>
                    <p>
                        {t("Any content violating this policy may be removed without prior notice. Accounts engaging in prohibited behavior may be suspended or permanently terminated.")}
                    </p>
                    <p>
                        {t("GCNETWORKS WITH LOGIC reserves the right to investigate violations and cooperate with law enforcement authorities when required.")}
                    </p>
                    <p>
                        {t("By using the website")} www.luvbinder.com, {t("users agree to comply with this policy.")}
                    </p>
                </div>
                <div className="pad10"></div>
                
                <div className="box">
                    <h3>{t("SAFETY & REPORTING POLICY")}</h3>
                    <p>
                        {t("GCNETWORKS WITH LOGIC is committed to maintaining a safe and respectful environment for users of the website")} www.luvbinder.com. {t("The platform is intended for lawful interactions between consenting adults.")}
                    </p>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("User Safety")}</h3>
                    <p>
                        {t("We take the safety of our users seriously and implement reasonable measures to detect and prevent abuse, harassment, exploitation, and illegal activities.")}
                    </p>
                    <p>{t("Users are expected to behave respectfully and must not engage in:")}</p>
                    <ul>
                        <li>{t("Harassment or abusive behavior")}</li>
                        <li>{t("Threats or intimidation")}</li>
                        <li>{t("Fraud or scams")}</li>
                        <li>{t("Impersonation")}</li>
                        <li>{t("Any activity related to exploitation or trafficking")}</li>
                    </ul>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Reporting Suspicious Activity")}</h3>
                    <p>
                        {t("Users may report suspicious behavior, inappropriate content, or violations of our policies through the platform's support or contact channels.")}
                    </p>
                    <p>{t("Reports may include but are not limited to:")}</p>
                    <ul>
                        <li>{t("Suspicious profiles")}</li>
                        <li>{t("Harassment or abusive messages")}</li>
                        <li>{t("Fraudulent activity")}</li>
                        <li>{t("Content that violates platform policies")}</li>
                        <li>{t("Potential illegal activity")}</li>
                    </ul>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Enforcement")}</h3>
                    <p>
                        {t("Reported content or accounts may be reviewed by the platform administration. If a violation is confirmed, the company may:")}
                    </p>
                    <ul>
                        <li>{t("Remove the content")}</li>
                        <li>{t("Suspend or permanently terminate the account")}</li>
                        <li>{t("Restrict platform access")}</li>
                        <li>{t("Cooperate with relevant authorities if required by law")}</li>
                    </ul>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Commitment")}</h3>
                    <p>
                        {t("GCNETWORKS WITH LOGIC remains committed to maintaining a safe online environment and encourages users to report any activity that may compromise the safety of the community.")}
                    </p>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("AGE VERIFICATION POLICY")}</h3>
                    <p>
                        {t("The website")} www.luvbinder.com {t("is intended strictly for adults.")}
                    </p>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Minimum Age Requirement")}</h3>
                    <p>
                        {t("All users must be at least 18 years of age to create an account or use the services provided on this platform.")}
                    </p>
                    <p>
                        {t("By accessing or using the website, users confirm that they meet the minimum age requirement.")}
                    </p>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Prohibition of Minors")}</h3>
                    <p>
                        {t("Accounts created by individuals under the age of 18 are strictly prohibited. Any account suspected of belonging to a minor may be suspended or permanently removed.")}
                    </p>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Monitoring and Enforcement")}</h3>
                    <p>
                        {t("The company may take reasonable steps to identify accounts that may belong to underage individuals. Where appropriate, accounts may be subject to verification procedures.")}
                    </p>
                    <p>
                        {t("Accounts confirmed to belong to minors will be permanently terminated.")}
                    </p>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Commitment")}</h3>
                    <p>
                        {t("GCNETWORKS WITH LOGIC is committed to protecting minors and ensuring that the platform is used only by adults in compliance with applicable laws.")}
                    </p>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Protection of Minors and Legal Cooperation")}</h3>
                    <p>
                        {t("The platform strictly prohibits the presence of minors. If the company becomes aware or has reasonable suspicion that a user may be under the age of 18, the account may be immediately suspended or permanently removed.")}
                    </p>
                    <p>
                        {t("Where appropriate, the company may report suspected cases involving minors or potential exploitation to the relevant law enforcement authorities and will cooperate with authorities in order to address and resolve such situations.")}
                    </p>
                </div>
                <div className="pad10"></div>
                <div className="box">
                    <h3>{t("Cooperation With Authorities")}</h3>
                    <p>
                        {t("If there is any suspicion or indication that the platform may be used in connection with human trafficking, sexual exploitation, forced labor, or other illegal activities, the company may take immediate action including the suspension or termination of the involved accounts.")}
                    </p>
                    <p>
                        {t("Where credible concerns arise, the company may report such activities to the relevant law enforcement authorities and cooperate fully with competent authorities in any investigation or legal process.")}
                    </p>
                    <p>
                        {t("The company may preserve and provide relevant information as permitted by applicable laws to support investigations aimed at preventing trafficking, exploitation, or other criminal activities.")}
                    </p>
                </div>
                <div className="pad10"></div>
            </div>
        </>
    );
}

export default HumanTracking;
